import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

const initialState = {
    viewType: 'CARD_VIEW' // 'CARD_VIEW' | 'TABLE_VIEW'
}

const dashboardViewSlice = createSlice({
    name: 'dashboardView',
    initialState,
    reducers: {
        setDashboardViewType: (state, { payload }) => {
            state.viewType = payload
        }
    }
})

export const { setDashboardViewType } = dashboardViewSlice.actions

export const useDashboardViewSelector = () =>
    useSelector((state) => state.dashboardView)

export default dashboardViewSlice.reducer
